import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVTpOrderdetCom} from '../containers'
function SVTpOrderdetComPage() {
    let { id,orderId } = useParams();
    let svparams = { 'id': id, orderId:orderId}
    return (
        <SVTpOrderdetCom svparams= {svparams} />
    );
}
export default SVTpOrderdetComPage